export default __webpack_public_path__ + "images/M4.160d8eb.png";